import { useState } from 'react';

import { selectSettings } from '@/ducks/common/settings/selectors';
import { useAppSelector } from '@/store';

export const useDisabledSailorModal = () => {
  const [isDisabledSailorModalOpen, setIsDisabledSailorModalOpen] = useState(false);

  const configServiceData = useAppSelector(selectSettings);

  const onDisabledSailorModalClick = () => {
    setIsDisabledSailorModalOpen((prev) => !prev);
  };

  const onSailorServiceBtnClick = () => {
    setIsDisabledSailorModalOpen(false);
    const landingPageUrl = configServiceData?.ContactUsUrl;
    if (landingPageUrl) {
      window.open(landingPageUrl, '_blank');
    }
  };

  return {
    isDisabledSailorModalOpen,
    onDisabledSailorModalClick,
    onSailorServiceBtnClick,
    setIsDisabledSailorModalOpen,
  };
};
